import { useEffect } from "react";
import useSWR from "swr";
import type { ResponseError } from "~/error";
import type { Session } from "./Session";

export const useSession = (
	onError?: (err: ResponseError) => void,
): [Session | undefined, boolean] => {
	const { data, error, isLoading } = useSWR<Session, ResponseError>(
		"/sessions/whoami",
	);

	useEffect(() => {
		if (error && onError) {
			onError(error);
		}
	}, [error, onError]);
	return [data, isLoading];
};
